// extracted by mini-css-extract-plugin
module.exports = {"content":"slogan_content__E1r8L","title":"slogan_title__Araap","text":"slogan_text__kd_PY"};